import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../App";
import MPCLogo from "../../Images/MPCLogo.png";
import LeaderBoardAd from "../../Components/LeaderBoardAd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faMobile,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { faGooglePlay, faAppStore } from "@fortawesome/free-brands-svg-icons";

const LiveScore = () => {
  const history = useHistory();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);
  const [showDeepLinkPrompt, setShowDeepLinkPrompt] = useState(false);
  const [appNotInstalled, setAppNotInstalled] = useState(false);
  const [gameKey, setGameKey] = useState(null);

  // Handle deep linking to MPC app - auto open
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const gameId = params.get("game");

    if (gameId) {
      // Check if device is desktop/TV (big screen)
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isMobile = /iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
        ua
      );

      // If it's a big screen (not mobile), open the browser link directly
      if (!isMobile) {
        window.location.href = `https://shrestham.com.np/MPC/V9?game=${encodeURIComponent(
          gameId
        )}`;
        return;
      }

      setShowDeepLinkPrompt(true);

      // Auto-open the app immediately
      const startTime = Date.now();
      window.location.href = `mpc://stream?game=${encodeURIComponent(gameId)}`;

      // Check if app opened by detecting if page is still visible after 2 seconds
      const checkTimer = setTimeout(() => {
        // If we're still here after 2 seconds, app likely isn't installed
        if (
          document.visibilityState === "visible" ||
          Date.now() - startTime > 2500
        ) {
          setAppNotInstalled(true);
        }
      }, 2000);

      // Clean up if user navigates away (app opened successfully)
      const visibilityHandler = () => {
        if (document.hidden) {
          clearTimeout(checkTimer);
        }
      };
      document.addEventListener("visibilitychange", visibilityHandler);

      return () => {
        clearTimeout(checkTimer);
        document.removeEventListener("visibilitychange", visibilityHandler);
      };
    }
  }, [location.search]);

  const handleInstallApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // iOS - redirect to App Store
      window.location.href = "itms-apps://itunes.apple.com/app/1599221145";
    } else if (/android/i.test(userAgent)) {
      // Android - redirect to Play Store
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.shrestha.MPC";
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const gameKey = params.get("game");
    setGameKey(gameKey);

    // Only redirect if there's NO game parameter (old behavior for backward compatibility)
    if (!gameKey) {
      const redirectUrl = `https://marriagepointcalculator-b6ae6.web.app/#/RealTimeScorePage`;
      const timer = setTimeout(() => {
        redirectToGame(redirectUrl);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [history, location.search]);

  useEffect(() => {
    // Google add scense script added
    const script = document.createElement("script");
    script.src = "https://pagead2.googlesyndication.com/pagead/js/";
    script.async = true;
    document.body.appendChild(script);
    return () => {};
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Clean up the timer when the component unmounts or when the countdown reaches 0
    return () => clearInterval(timer);
  }, []);

  function redirectToGame(redirectUrl) {
    window.location.href = redirectUrl;
  }

  return (
    <>
      {(() => {
        // Determine platform to choose install icon
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
        const isAndroid = /android/i.test(ua);
        // store on window for later use inside JSX below
        window.__mpc_install_icon = isAndroid
          ? faGooglePlay
          : isIOS
          ? faAppStore
          : faDownload;
        return null;
      })()}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      {/* Deep Link Prompt for MPC App */}
      {showDeepLinkPrompt && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            backgroundColor: "#ffffff",
            padding: "20px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              maxWidth: "500px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
            }}
          >
            <h1
              style={{
                marginBottom: "15px",
                fontWeight: "600",
                color: "#dc3545",
              }}
            >
              Live Scoreboard
            </h1>
            <img
              src={MPCLogo}
              alt="MPC Logo"
              style={{
                width: "170px",
                height: "170px",
                marginBottom: "15px",
                objectFit: "contain",
              }}
            />
            {!appNotInstalled ? (
              <>
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  Opening Marriage Point Calculator app...
                </p>
                <div
                  style={{
                    fontSize: "30px",
                    margin: "15px 0",
                    animation: "spin 1s linear infinite",
                  }}
                >
                  ⏳
                </div>
                <p
                  style={{ color: "#666", fontSize: "12px", margin: "10px 0" }}
                >
                  If the app doesn't open automatically, it may not be installed
                </p>
              </>
            ) : (
              <>
                <h3>
                  <p
                    style={{
                      color: "#555",
                      fontSize: "22px",
                      marginBottom: "15px",
                      lineHeight: "1.5",
                      padding: "0 10px",
                    }}
                  >
                    Please scan the QR code after installing or updating the
                    mobile app to version 11.0.2 or later.
                  </p>
                  <p
                    style={{
                      color: "#555",
                      fontSize: "12px",
                      marginBottom: "15px",
                      lineHeight: "1.5",
                      padding: "0 10px",
                    }}
                  >
                    Game ID: {gameKey}
                  </p>
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    padding: "0 10px",
                  }}
                >
                  <button
                    onClick={handleInstallApp}
                    style={{
                      padding: "12px 20px",
                      fontSize: "15px",
                      cursor: "pointer",
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={window.__mpc_install_icon || faDownload}
                      style={{ marginRight: "8px" }}
                    />
                    Click here to install or update the Mobile App
                  </button>
                  <button
                    onClick={() => {
                      const params = new URLSearchParams(location.search);
                      const gameId = params.get("game");
                      window.location.href = `mpc://stream?game=${encodeURIComponent(
                        gameId || ""
                      )}`;
                    }}
                    style={{
                      padding: "12px 20px",
                      fontSize: "15px",
                      cursor: "pointer",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faMobile}
                      style={{ marginRight: "8px" }}
                    />
                    Open and watch on the Mobile App
                  </button>
                  For TV or computer: Press the button "Open in browser" to view
                  on a larger screen.
                  <button
                    onClick={() => {
                      const params = new URLSearchParams(location.search);
                      const gk = params.get("game");
                      window.location.href = `https://shrestham.com.np/MPC/V9?game=${
                        gk || ""
                      }`;
                    }}
                    style={{
                      padding: "12px 20px",
                      fontSize: "15px",
                      cursor: "pointer",
                      backgroundColor: "#ba6e6eff",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faGlobe}
                      style={{ marginRight: "8px" }}
                    />
                    Open in browser
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <LeaderBoardAd adSlot="7757082732" />
    </>
  );
};

export default LiveScore;
